// extracted by mini-css-extract-plugin
export default {"menuActions":"SiteMenu_menuActions__qju58","colorExitSite":"SiteMenu_colorExitSite__9-SAd","colorMenu":"SiteMenu_colorMenu__5eRp7","colorIconMenu":"SiteMenu_colorIconMenu__nwXLh"};